import type { RouteLocationAsRelative } from 'vue-router'

import { ShiftID } from './models/shift'

export interface ShiftRef {
  id: ShiftID
  orgSlug: string
}

export const shiftRoutes = {
  activity: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/schedule/activity/'> => ({
    name: '/(app)/[org]/schedule/activity/',
    params: { org },
  }),

  calendar: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/schedule/calendar/'> => ({
    name: '/(app)/[org]/schedule/calendar/',
    params: { org },
  }),

  list: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/schedule/shifts/'> => ({
    name: '/(app)/[org]/schedule/shifts/',
    params: { org },
  }),

  create: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/schedule/shifts.wizard'> => ({
    name: '/(app)/[org]/schedule/shifts.wizard',
    params: { org },
  }),

  detail: (
    s: ShiftRef,
  ): RouteLocationAsRelative<'/(app)/[org]/schedule/shifts/[id]/'> => ({
    name: '/(app)/[org]/schedule/shifts/[id]/',
    params: { org: s.orgSlug, id: s.id },
  }),
}
